import { render, staticRenderFns } from "./SectorManagement.vue?vue&type=template&id=69720564&scoped=true"
import script from "./SectorManagement.vue?vue&type=script&lang=js"
export * from "./SectorManagement.vue?vue&type=script&lang=js"
import style0 from "./SectorManagement.vue?vue&type=style&index=0&id=69720564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69720564",
  null
  
)

export default component.exports